import { PiCheckCircleBold } from 'react-icons/pi'

import { useApproveCampaignColumn } from 'services/campaignColumns/hooks'

interface Props {
  campaignId: number
  columnId: number
}

export function ApproveButton({ campaignId, columnId }: Props) {
  const approve = useApproveCampaignColumn(campaignId)
  return (
    <button
      type="button"
      onClick={() => approve.mutate(columnId)}
      disabled={approve.isPending}
      className="ml-2 inline-flex items-center gap-1 border-none bg-transparent p-0 text-xs font-medium text-brand-bright transition-colors hover:text-brand-active disabled:opacity-50"
    >
      <PiCheckCircleBold className="h-3.5 w-3.5" />
      {approve.isPending ? 'Approving…' : 'Approve'}
    </button>
  )
}
